import { User } from '@prisma/client'
import { Divider, Form, Switch, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { AppSessionType } from '~/features/appSession/common'
import { FeatureFormConfigurationClient } from '~/features/formConfiguration/client'
import { Toolbox } from '~/plugins/toolbox/shared'
import { OnboardingValues } from '../../common'

type Props = {
  user: User
  appSession: AppSessionType
}

export const Settings: React.FC<Props> = ({ user, appSession }) => {
  const configuration = { timezone: user.timezone }

  const values = (appSession?.values?.onboarding ?? {}) as OnboardingValues

  const valuesSafe = {
    ...values,
    article: {
      ...values.article,
      isActive: Toolbox.Utility.isDefined(values.article?.rule),
    },
    webServices: {
      provider: 'wordpress',
    },
  } as OnboardingValues

  const logic = CommonClient.Form.useLogic<OnboardingValues>({
    appSession,
    cleanValues(values) {
      if (!values.article?.isActive) {
        return {
          ...values,
          article: {
            isActive: false,
          },
        }
      }
    },
  })

  return (
    <>
      <CommonClient.Form.Wrapper {...logic} values={valuesSafe}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          Daily Posts
        </Typography.Title>

        <Divider className="my-3" />

        <CommonClient.Form.InputWrapper
          label="Daily Posts"
          description="Receive daily list of posts ideas"
        >
          <Form.Item name={['article', 'isActive']}>
            <Switch size="small" />
          </Form.Item>
        </CommonClient.Form.InputWrapper>

        <Form.Item<OnboardingValues>
          shouldUpdate={(valuesBefore, valuesAfter) =>
            valuesBefore?.article?.isActive !== valuesAfter?.article?.isActive
          }
        >
          {instance => {
            const isActive = instance.getFieldValue(['article', 'isActive'])

            if (!isActive) {
              return <></>
            }

            return (
              <CommonClient.Form.InputWrapper
                label="Message time"
                description="Choose at what time you want to receive the list"
              >
                <Form.Item
                  name={['article', 'rule']}
                  getValueFromEvent={items => items[0]}
                >
                  <FeatureFormConfigurationClient.RRulePicker
                    type="DAILY"
                    formValuesConfiguration={configuration}
                  />
                </Form.Item>
              </CommonClient.Form.InputWrapper>
            )
          }}
        </Form.Item>

        {/* <Typography.Title level={4} style={{ margin: 0 }}>
          Website
        </Typography.Title>

        <Divider className="my-3" />

        <Form.Item name={['webServices', 'provider']}>
          <Radio.Group
            block={true}
            optionType="button"
            buttonStyle="solid"
            options={[
              {
                label: 'Wordpress',
                value: 'wordpress',
              },
            ]}
          />
        </Form.Item>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {instance => {
            const provider = instance.getFieldValue(['webServices', 'provider'])

            if (provider === 'wordpress') {
              return (
                <CommonClient.Form.InputWrapper label="Add your Wordpress Account">
                  <Form.Item name={['webServices', 'accountWordpress']}>
                    <SelectProviderAccount providerKey="wordpress" />
                  </Form.Item>
                </CommonClient.Form.InputWrapper>
              )
            }
          }}
        </Form.Item> */}
      </CommonClient.Form.Wrapper>
    </>
  )
}
